import { render, staticRenderFns } from "./viewSendMessageContent.vue?vue&type=template&id=c4b6e216"
import script from "./viewSendMessageContent.vue?vue&type=script&lang=js"
export * from "./viewSendMessageContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports